import { render } from "./Retailers.vue?vue&type=template&id=3d8ef191&scoped=true"
import script from "./Retailers.vue?vue&type=script&lang=js"
export * from "./Retailers.vue?vue&type=script&lang=js"

import "./Retailers.vue?vue&type=style&index=0&id=3d8ef191&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8ef191"]])

export default __exports__